globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.GoogleMyBusiness = appCustomerSpace.Modules.GoogleMyBusiness || {};

appCustomerSpace.Modules.GoogleMyBusiness.PhoneError = (function()
{

    function PhoneError() {}

    PhoneError.display = function() {
        var form = this;

        function displayPhonneError($input, state) {
            if($input.val() == "") return;

            if(state) {
                if(!$input.closest('.form-group').find('.validation-error-label').length) {
                    $input.closest('.form-group').append('<p class="validation-error-label">Numéro incorrect</p>');
                }
            } else {
                $input.closest('.form-group').find('.validation-error-label').remove();
            }
        }

        $(".intl-tel-input").each(function(){
            var $this = $(this);
            $this.intlTelInput({
                initialCountry: $(this).data('country-code'),
                separateDialCode: true,
                preferredCountries: ["fr"],
                formatOnDisplay: true,
                hiddenInput: $this.data('input-name'),
                utilsScript: "intlTelInput/utils.js"
            });

            displayPhonneError($this, !$this.intlTelInput('isValidNumber'));

            $this.on('change', function(){
                displayPhonneError($this, !$this.intlTelInput('isValidNumber'));
            })
        });
    }

    return PhoneError;

})();
